"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHAT_SETTINGS = void 0;
const DEFAULT_CHAT_SETTINGS = {
    imageModel: 'flux-schnell',
    videoModel: null,
    voice: null,
    chatLearning: false,
    enableAIAssistant: true,
    temperature: 0.7,
    maxTokens: null,
    extendedContext: false,
    thinking: true
};
exports.DEFAULT_CHAT_SETTINGS = DEFAULT_CHAT_SETTINGS;
